import { useState } from 'react'
import DashboardBusinessesList from '../../../../../components/Lists/DashboardBusinessesList'
import Select from '../../../../../components/Inputs/Select'
import { DateTime } from 'luxon'

import {
  InfoContainer,
  FilterContainer,
  SubTitle
} from '../../styles'

export default function BusinessesByFrequency ({
  data: businesses,
  order = 'desc',
  month = DateTime.now ().month,
  year = DateTime.now ().year
}) {
  const selectedDate = DateTime.local (year, month).setLocale ('pt-BR')
  const formattedDate = selectedDate.toFormat ('MMM yyyy')
  const [monthFilter, setMonthFilter] = useState ({
    label: formattedDate,
    value: formattedDate
  })

  if (!businesses || Object.keys (businesses).length === 0) {
    return null
  }

  return (
    <InfoContainer>
      <SubTitle>
        Top 10 salões que {order === 'desc' ? 'mais' : 'menos'} atenderam à Cutilei
      </SubTitle>
      <FilterContainer>
        <Select
          placeholder='Período...'
          value={monthFilter}
          options={Object.keys (businesses).map (month => ({
            label: month, value: month
          }))}
          onChange={(_, option) => setMonthFilter (option)}
          containerStyles={{width: 250}}
        />
      </FilterContainer>
      <DashboardBusinessesList businesses={businesses[monthFilter.value]}/>
    </InfoContainer>
  )
}
